<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c05"><a id="page05"></a>Don’t Pass This Way Again!</h1>
<p class="nonindent"><span class="dropcaps">T</span>he South Dakota Supreme Court upheld a ruling in September 1994, citing the husband as the cause of a couple’s troubles. The husband had, among other bad habits, a tendency to pass gas around the house and get angry with his wife when she complained. The wife claimed her husband could easily regulate his odiferous emissions and would break wind as a “retaliation thing.”<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<p class="pagebreak"> </p>
<p class="extract"><a id="page06"></a><img alt="" src="OEBPS/images/Greg_9780740792069_epub_6-1_r1.jpg"/></p>
<p class="center">—750.32, Michigan Penal Code Act 328 of 1931</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c05_r1.vue?936bf2e2